import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SEO from "../SEO/SEO";
import { motion } from "framer-motion";
import Adelaidebanner from "../Assets/Services/Adelaide-banner-img.png";
import Officecleaning from "../Assets/CommercialCleaning/Once-off-Cleaning.png";
import AgedCare from "../Assets/CommercialCleaning/Regular-house-cleaning.png";
import Schoolcleaning from "../Assets/CommercialCleaning/End-of-Lease-Cleaning.png";
import trueicon from "../Assets/HouseCleaning/true-icon.png";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import getaquote from "../Assets/get_a_quote.jpg";
import FaqPage from "../Services/FaqPage";
import SuburbsSection from "./SuburbsSection";
import React, { useState, useEffect, useRef } from "react";
import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";

const services = [
  {
    title: "Improved independence",
    desc: "A clean and organized home can help you live more independently and safely.",
    img: Officecleaning,
    alt: "Improved independence",
  },
  {
    title: "Reduced stress and anxiety",
    desc: "Knowing your home is clean can help you relax and focus on other things.",
    img: AgedCare,
    alt: "Reduced stress and anxiety",
  },
  {
    title: "More time for yourself",
    desc: "Let us take care of the cleaning so you can spend more time on the things you enjoy.",
    img: Schoolcleaning,
    alt: "More time for yourself",
  },
];

const NDISCleaning = () => {
  const [activeIndex, setActiveIndex] = useState(1); // second item open by default

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const [item, setItem] = useState(null);

  useEffect(() => {
    api.get(`/whychoosehousecleaningservice/view/9`).then((res) => {
      setItem(res.data);
    });
  }, []);

  // Fetch slider content from API
  const [sliderData, setSliderData] = useState({
    headline: "NDIS Cleaning Services",
    subtext: "",
  });

  useEffect(() => {
    api
      .get("service-slider/ndis-cleaning")
      .then((res) => {
        if (res.data) {
          setSliderData({
            headline: res.data.headline,
            subtext: res.data.subtext,
          });
        }
      })
      .catch((err) => console.error("Slider Fetch Error", err));
  }, []);

  return (
    <div>
      <SEO />
      <Header />

      <section
        className="hero-section py-24 text-white text-center relative"
        style={{
          background: `url(${Adelaidebanner}) center/cover`,
          position: "relative",
        }}
      >
        <div className="container mx-auto px-4 relative z-10 mt-5">
          <motion.h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 mt-5"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {sliderData.headline || "NDIS Cleaning Services"}
          </motion.h1>

          {sliderData.subtext && (
            <motion.p
              className="text-lg mb-4 px-4"
              style={{ maxWidth: "800px", margin: "0 auto" }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              {sliderData.subtext}
            </motion.p>
          )}

          <motion.p
            className="text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <span>
              Home
              <Link
                to="/adelaide-service"
                className="text-decoration-none text-white"
              >
                / Services
              </Link>
            </span>
          </motion.p>

          <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
            <Link
              to="/free-quote"
              className="btn btn-danger d-inline-flex align-items-center gap-2"
            >
              Get Free Quote <FaArrowRight />
            </Link>
            <Link
              to="tel:0406958557"
              className="btn btn-primary d-inline-flex align-items-center gap-2"
            >
              Call Now <FaPhoneAlt />
            </Link>
          </div>
        </div>

        {/* Optional Overlay */}
        <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
      </section>

      <section className="why-choose py-5">
        <div className="why-container container d-flex flex-column flex-lg-row align-items-center justify-content-between">
          <div className="why-text mb-4 mb-lg-0">
            <h2 className="fw-bold mb-4">
              {item?.heading.split(" ").slice(0, -3).join(" ")}{" "}
              <span>{item?.heading.split(" ").slice(-3).join(" ")}</span>
            </h2>
            <ul className="list-unstyled">
              {item?.points.map((point, index) => (
                <li className="mb-3 d-flex align-items-start" key={index}>
                  <img src={trueicon} alt="check" className="me-2 icon" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="why-image text-center">
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.before_image}`}
                  alt="Before"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">Before</div>
              </div>

              <div className="fw-bold display-5 mx-2 d-none d-md-block">→</div>

              <div>
                <img
                  src={`${PUBLIC_BASE_URL}${item?.after_image}`}
                  alt="After"
                  className="img-fluid rounded shadow"
                  style={{ maxWidth: "300px" }}
                />
                <div className="caption fw-bold mt-2">After</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-options text-center">
        <div className="container">
          <h2 className="section-title">Why Invest in NDIS cleaning?</h2>
          <div className="row">
            {services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 mb-4" key={index}>
                <div className="service-card">
                  <div className="icon-box mb-3">
                    <img
                      src={service.img}
                      alt={service.alt}
                      className="img-fluid"
                    />
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FaqPage categoryId="NDIS cleaning" />

      <SuburbsSection />

      <section className="quote-section pt-5">
        <div className="row">
          <div className="col-md-6">
            <div className="quote-container container text-center">
              <h2 className=" fw-bold mb-3"> Book NDIS Cleaning Services Now!</h2>
              <p className="mb-4 text-muted mt-5">
                Looking for reliable and friendly support? Shiny Cleaning is here for you. Our team delivers trusted NDIS cleaning services in Adelaide & Melbourne , helping you maintain a cleaner, safer and more comfortable home.
 <br/>👉 Contact us today for a free consultation or to book your first clean.
              </p>

              <div className="quote-buttons d-flex flex-column flex-md-row justify-content-center gap-3 mt-5">
                <Link
                  to="/free-quote"
                  className="btn btn-outline-info d-inline-flex align-items-center gap-2 "
                >
                  Get Free Quote <FaArrowRight />
                </Link>
                <Link
                  to="tel:0406958557"
                  className="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                >
                  Call Now <FaPhoneAlt />
                </Link>
              </div>
            </div>
          </div>

          <div className="col-md-6 px-5">
            <img src={getaquote} className="h-75 w-75" />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NDISCleaning;
